import React from "react";
import LoginForm from "../Forms/LoginForm";
import RegisterForm from "../Forms/RegisterForm";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
    textAlign: "center",
  },
}));

const LoginContent = (props) => {
  const classes = useStyles();

  let tabValue = props.tabNumber;
  let cardContent = null;

  if (tabValue === 0) {
    cardContent = <LoginForm />;
  } else if (tabValue === 1) {
    cardContent = <RegisterForm />;
  } else cardContent = null;
  return <div className={classes.root}>{cardContent}</div>;
};

export default LoginContent;
